import React from "react";
import Header from "./../components/header/Header";
import Footer from "./../components/footer/Footer";
import RegistrationContent from "../components/regPage/RegContent";

const Enter = () => {
  return (
    <div className="wrapper">
      <Header />
      <RegistrationContent />
      <Footer />
    </div>
  );
};

export default Enter;
